<template>
  <div
    class="modal-wrap"
    :style="{display: isShow ? '' : 'none'}"
    @click.self="$emit('close')"
  >
    <div class="modal-dialog">
      <a
        href="#"
        class="modal-close"
        @click.prevent="$emit('close')"
      />
      <div class="modal-title">
        {{ title }}
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: Boolean,
    title: String,
  },
}
</script>

<style scoped>
  .modal-wrap {
    position: fixed;
    z-index: 1100;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    display: flex;
    background: rgba(0, 0, 0, .8);
  }
  .modal-dialog {
    position: relative;
    margin: auto;
    padding: 48px 56px;
    background: white;
    border-bottom: 3px solid #f58214;
  }
  .modal-close {
    position: absolute;
    right: 0;
    top: 0;
    width: 42px;
    height: 42px;
    background: url(../../public/icons/cross.svg) no-repeat center center;
  }
  .modal-title {
    margin-bottom: 31px;
    font-size: 36px;
    font-family: Oswald, Roboto, sans-serif;
    text-align: center;
    text-transform: uppercase;
    color: #0B53B3;
  }
</style>
